import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { coordinates: '_geoCoordinates' };
var _businessContactData = { address: '_address' };
var _geoCoordinates = { latitude: 'DOUBLE', longitude: 'DOUBLE' };
var _properties = { address: '_address' };
var _propertiesReadRequest = { fields: 'google.protobuf.FieldMask' };
var _propertiesReadResponse = { properties: '_properties' };
var _propertiesUpdateRequest = {
    fields: 'google.protobuf.FieldMask',
    properties: '_properties',
};
var _propertiesUpdateResponse = {};
var _updateBusinessContactRequest = {
    fields: 'google.protobuf.FieldMask',
    businessContact: '_businessContactData',
};
var _updateBusinessContactResponse = {};
var _updateBusinessProfileRequest = { fields: 'google.protobuf.FieldMask' };
var _updateBusinessProfileResponse = {};
var _updateBusinessScheduleRequest = {};
var _updateBusinessScheduleResponse = {};
var _updateConsentPolicyRequest = {};
var _updateConsentPolicyResponse = {};
function resolveComWixpressSitepropertiesApiV4SitePropertiesV4Url(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/site-properties-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/site-properties-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/site-properties-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/site-properties-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/site-properties-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/site-properties-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/site-properties/v4/properties',
                destPath: '/v4/properties',
            },
            {
                srcPath: '/site-properties',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a current snapshot of a site's properties. */
export function read(payload) {
    var _a = serializer(_propertiesReadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_propertiesReadResponse, {
        _address: _address,
        _geoCoordinates: _geoCoordinates,
        _properties: _properties,
    }).fromJSON;
    function __read(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.siteproperties.v4.properties',
            method: 'GET',
            methodFqn: 'com.wixpress.siteproperties.api.v4.SitePropertiesV4.Read',
            url: resolveComWixpressSitepropertiesApiV4SitePropertiesV4Url({
                protoPath: '/v4/properties',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressSitepropertiesApiV4SitePropertiesV4Url({
                        protoPath: '/v4/properties',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __read.fromReq = fromReq;
    __read.__isAmbassador = true;
    return __read;
}
/** Updates one or more of a site's properties. The site ID is resolved via the Identification Service. */
export function update(payload) {
    var _a = serializer(_propertiesUpdateRequest, { _address: _address, _geoCoordinates: _geoCoordinates, _properties: _properties }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_propertiesUpdateResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.siteproperties.v4.properties',
            method: 'PATCH',
            methodFqn: 'com.wixpress.siteproperties.api.v4.SitePropertiesV4.Update',
            url: resolveComWixpressSitepropertiesApiV4SitePropertiesV4Url({
                protoPath: '/properties',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/** Updates a site's business profile. */
export function updateBusinessProfile(payload) {
    var _a = serializer(_updateBusinessProfileRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBusinessProfileResponse, {}).fromJSON;
    function __updateBusinessProfile(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.siteproperties.v4.properties',
            method: 'POST',
            methodFqn: 'com.wixpress.siteproperties.api.v4.SitePropertiesV4.UpdateBusinessProfile',
            url: resolveComWixpressSitepropertiesApiV4SitePropertiesV4Url({
                protoPath: '/v4/properties/business-profile',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBusinessProfile.fromReq = fromReq;
    __updateBusinessProfile.__isAmbassador = true;
    return __updateBusinessProfile;
}
/** Updates a site's business contact information. */
export function updateBusinessContact(payload) {
    var _a = serializer(_updateBusinessContactRequest, { _address: _address, _businessContactData: _businessContactData, _geoCoordinates: _geoCoordinates }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBusinessContactResponse, {}).fromJSON;
    function __updateBusinessContact(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.siteproperties.v4.properties',
            method: 'POST',
            methodFqn: 'com.wixpress.siteproperties.api.v4.SitePropertiesV4.UpdateBusinessContact',
            url: resolveComWixpressSitepropertiesApiV4SitePropertiesV4Url({
                protoPath: '/v4/properties/business-contact',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBusinessContact.fromReq = fromReq;
    __updateBusinessContact.__isAmbassador = true;
    return __updateBusinessContact;
}
/** Updates a site's business schedule. */
export function updateBusinessSchedule(payload) {
    var _a = serializer(_updateBusinessScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBusinessScheduleResponse, {}).fromJSON;
    function __updateBusinessSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.siteproperties.v4.properties',
            method: 'POST',
            methodFqn: 'com.wixpress.siteproperties.api.v4.SitePropertiesV4.UpdateBusinessSchedule',
            url: resolveComWixpressSitepropertiesApiV4SitePropertiesV4Url({
                protoPath: '/v4/properties/business-schedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBusinessSchedule.fromReq = fromReq;
    __updateBusinessSchedule.__isAmbassador = true;
    return __updateBusinessSchedule;
}
/** Updates a site's default consent policy. */
export function updateConsentPolicy(payload) {
    var _a = serializer(_updateConsentPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateConsentPolicyResponse, {}).fromJSON;
    function __updateConsentPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.siteproperties.v4.properties',
            method: 'POST',
            methodFqn: 'com.wixpress.siteproperties.api.v4.SitePropertiesV4.UpdateConsentPolicy',
            url: resolveComWixpressSitepropertiesApiV4SitePropertiesV4Url({
                protoPath: '/v4/properties/policy',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateConsentPolicy.fromReq = fromReq;
    __updateConsentPolicy.__isAmbassador = true;
    return __updateConsentPolicy;
}
//# sourceMappingURL=http.impl.js.map